import React from 'react';
import { Loader } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import {
  AccountInfoType,
  AllUsersType,
  ConfirmationType,
  ContactFormType,
} from '../../../../shared/types';
import { Center } from '../../../../shared/styles';
import ContactDisplay from '../components/ContactDisplay';
import { useGetContact } from '../hooks';

type ViewContactProps = {
  allUsers?: AllUsersType;
  contactForm: ContactFormType;
  accountInfo?: AccountInfoType;
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
};

const ViewContact = (props: ViewContactProps) => {
  const { t } = useTranslation();
  const { contactForm, accountInfo, setConfirmationData } = props;
  const { contactId }: any = useParams();

  const {
    data: contactData = {},
    isLoading: isLoadingContact,
    isError: isContactError,
    refetch: refetchContacts,
  } = useGetContact(contactId);

  if (isContactError)
    return <Center>{t('empty_state.message.network_error')}</Center>;

  if (!isLoadingContact && !contactData.id)
    return <Center>{t('contacts.not_found')}</Center>;

  return isLoadingContact ? (
    <Center>
      <Loader />
    </Center>
  ) : (
    <ContactDisplay
      contactId={contactId}
      setConfirmationData={setConfirmationData}
      contactForm={contactForm}
      contactData={contactData}
      refetchContacts={refetchContacts}
      accountInfo={accountInfo}
    />
  );
};

export default ViewContact;
